import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { DATA_SOURCE_ICONS } from './constants';
import { DataSourceIconBaseProps } from './types';
import CsvFileIcon from '@/assets/datasourcetypes/CSV_FILE.svg?react';
import MicrosoftDynamics365Logo from '@/assets/icons/microsoft-dynamics-365-logo.svg?react';
import { DataSourceIDEnum } from '@/models/dataSource';

type DataSourceIconProps = DataSourceIconBaseProps & {
  type: string;
};

const FALLBACK_ICONS: Partial<Record<DataSourceIDEnum, FC<DataSourceIconBaseProps>>> = {
  [DataSourceIDEnum.D365BusinessCentral]: MicrosoftDynamics365Logo,
};

const DEFAULT_FALLBACK_ICON = CsvFileIcon;

export const DataSourceIcon: FC<DataSourceIconProps> = ({ type, className }) => {
  const Icon =
    DATA_SOURCE_ICONS[type as DataSourceIDEnum] ??
    FALLBACK_ICONS[type as DataSourceIDEnum] ??
    DEFAULT_FALLBACK_ICON;

  return <Icon className={twMerge('size-12 shrink-0 text-brand-500', className)} />;
};
